/* eslint-disable react/destructuring-assignment */
// eslint-disable-next-line no-useless-escape
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.student'),
      field: 'medication.student.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { medication } = rowData;
        return (
          <span className="tooltip-test" title={medication.student.fullName}>
            {medication.student.fullName}
          </span>
        );
      },
    },
    {
      title: t('general.classes-names'),
      field: 'medication.student.classesNames',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { medication } = rowData;
        return (
          <span
            className="tooltip-test"
            title={medication.student.classesNames}
          >
            {medication.student.classesNames}
          </span>
        );
      },
    },
    {
      title: t('mnt_medication.name'),
      field: 'medication.name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { medication } = rowData;
        return (
          <span className="tooltip-test" title={medication.name}>
            {medication.name}
          </span>
        );
      },
    },

    {
      title: t('mnt_medication.dosage'),
      field: 'medication.dosage',
      cellStyle: textEllipsis,
    },
    {
      title: t('mnt_medication.routeAdministration'),
      field: 'medication.routeAdministration',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { medication } = rowData;
        return (
          <span className="tooltip-test" title={medication.routeAdministration}>
            {medication.routeAdministration}
          </span>
        );
      },
    },
    {
      title: t('general.hour'),
      field: 'shouldApplicationHour',
    },
    {
      title: t('mnt_medication.requestDate'),
      field: 'formattedshouldApplicationDate',
    },
    {
      title: t('mnt_medication.requester'),
      field: 'medication.requester',
      cellStyle: textEllipsis,
    },
    {
      title: t('general.observations'),
      field: 'medication.observation',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { medication } = rowData;
        return (
          <span className="tooltip-test" title={medication.observation}>
            {medication.observation}
          </span>
        );
      },
    },
  ];
}
